export const stakingLang = {
    title: {
        'en': 'STAKING $ARTY',
        'fr': 'STAKING D$ARTY',
        'de': '$ARTY STAKEN',
        'ko': '$ARTY 코인 스테이킹',
        'ch': '质押 $ARTY 代币',
        'ru': 'СТЕЙКИНГ $ARTY',
        'it': 'STAKING $ARTY',
        'jap': '$ARTYコインを賭ける',
        'port': 'STAKE $ARTY ',
        'turk': '$ARTY HİSSESİ ALMA',
        'viet': 'STAKE ARTY$',
        'spa': 'STAKING $ARTY',
        'arab': 'تخزين $ARTY'
    },
    available: {
        'en': 'All Available tokens:',
        'fr': 'Tous les jetons disponibles:',
        'de': 'Alle verfügbaren Token:',
        'ko': '사용 가능한 모든 토큰:',
        'ch': '所有可用代币：',
        'ru': 'Все Доступные Токены:',
        'it': 'Tutti i token disponibili:',
        'jap': '利用可能なすべてのトークン：',
        'port': 'Todos os tokens disponíveis:',
        'turk': 'Mevcut Tüm Tokenler:',
        'viet': 'Tất cả token sẵn có:',
        'spa': 'Todos los tokens disponibles:',
        'arab': 'جميع العملات المتاحة:'
    },
    profit: {
        'en': 'Profit',
        'fr': 'Gains',
        'de': 'Profit',
        'ko': '수익',
        'ch': '收益',
        'ru': 'Прибыль',
        'it': 'Profitto:',
        'jap': '利益：',
        'port': 'Lucro:',
        'turk': 'Kâr:',
        'viet': 'Lợi nhuận:',
        'spa': 'Beneficio:',
        'arab': 'الفائدة:'
    },
    days30: {
        'en': '30 days',
        'fr': '30 jours',
        'de': '30 Tage',
        'ko': '30일',
        'ch': '30 天',
        'ru': '30 дней',
        'it': '30 giorni',
        'jap': '30日間',
        'port': '30 dias',
        'turk': '30 gün',
        'viet': '30 ngày',
        'spa': '30 días',
        'arab': '30 يوما'
    },
    enter_amount: {
        'en': 'Enter amount',
        'fr': 'Saisissez le montant',
        'de': 'Anzahl eingeben',
        'ko': '금액 입력',
        'ch': '输入金额',
        'ru': 'Введите количество',
        'it': 'Inserisci importo',
        'jap': '金額を入力',
        'port': 'Insira o valor',
        'turk': 'Miktar girin',
        'viet': 'Nhập số lượng',
        'spa': 'Introducir importe',
        'arab': 'أدخل المبلغ'
    },
    minimum: {
        'en': 'Minimum',
        'fr': 'Minimum',
        'de': 'Mindestens',
        'ko': '최소',
        'ch': '最低',
        'ru': 'Минимум',
        'it': 'Minimo',
        'jap': '最小',
        'port': 'Minimo',
        'turk': 'En az',
        'viet': 'Tối thiểu',
        'spa': 'Mínimo',
        'arab': 'الحد الأدنى'
    },
    maximum: {
        'en': 'Maximum',
        'fr': 'Maximal',
        'de': 'Maximal',
        'ko': '최대',
        'ch': '最大值',
        'ru': 'Максимум',
        'it': 'Massimo',
        'jap': '最大',
        'port': 'Maximo',
        'turk': 'Maksimum',
        'viet': 'Tối đa',
        'spa': 'Máximo',
        'arab': 'الحد الأقصى'
    },
    maximum_available: {
        'en': 'Maximum Available:',
        'fr': 'Maximum disponible:',
        'de': 'Maximal verfügbar:',
        'ko': '최대 사용 가능:',
        'ch': '最大可用：',
        'ru': 'Доступный Максимум:',
        'it': 'Massimo Disponibile:',
        'jap': '利用可能な最大値：',
        'port': 'Máximo disponível:',
        'turk': 'Azami Mevcut:',
        'viet': 'Tối đa sẵn có:',
        'spa': 'Máximo disponible:',
        'arab': 'الحد الأقصى المتاح:'
    },
    hold: {
        'en': 'Hold',
        'fr': 'Détenir',
        'de': 'Halten',
        'ko': '보유',
        'ch': '持有',
        'ru': 'Заморозка',
        'it': 'Tieni',
        'jap': '保有',
        'port': 'Manter',
        'turk': 'Beklet',
        'viet': 'Nắm giữ',
        'spa': 'Esperar',
        'arab': 'توقف'
    },
    total_profit: {
        'en': 'Total with profit:',
        'fr': 'Total (gains inclus):',
        'de': 'Gesamt mit Profit:',
        'ko': '수익 포함 합계:',
        'ch': '总收益：',
        'ru': 'Всего с прибылью:',
        'it': 'Totale con profitto:',
        'jap': '利益を含む合計：',
        'port': 'Total com lucro:',
        'turk': 'Kâr ile toplam:',
        'viet': 'Tổng lợi nhuận:',
        'spa': 'Total con beneficios:',
        'arab': 'إجمالي الربح:'
    },
    stake_arty: {
        'en': 'Stake $ARTY',
        'fr': 'Placer les jetons $ARTY en staking',
        'de': '$ARTY staken',
        'ko': '$ARTY 스테이킹',
        'ch': '质押 $ARTY',
        'ru': 'Стейкать $ARTY',
        'it': 'Metti in staking $ARTY',
        'jap': '$ARTYを賭ける',
        'port': 'Stake $ARTY',
        'turk': '$ARTY Hissesi Al',
        'viet': 'Stake ARTY$',
        'spa': 'STAKEAR $ARTY',
        'arab': 'حصة $ARTY'
    },
    stake_not_available: {
        'en': 'Staking will be available soon.',
        'fr': 'Le staking sera bientôt disponible.',
        'de': 'Staking ist in Kürze verfügbar.',
        'ko': '곧 스테이킹을 이용할 수 있습니다.',
        'ch': '即将推出质押功能。',
        'ru': 'Стейкинг будет доступен в ближайшее время.',
        'it': 'Lo staking sarà disponibile a breve.',
        'jap': '賭けはまもなく利用可能になります。',
        'port': 'O staking estará disponível em breve.',
        'turk': 'Hisse alımı yakında kullanılabilir olacaktır.',
        'viet': 'Tính năng stake sẽ sớm khả dụng.',
        'spa': 'El "staking" estará disponible pronto',
        'arab': 'التخزين سيكون متاحا قريبا.'
    },
    tool: {
        'en': 'Tool that increase your profits with one button',
        'fr': 'Outil qui augmente vos profits avec un seul bouton',
        'de': 'Tool, das Ihre Profite mit einem Knopfdruck steigert',
        'ko': '버튼 하나로 수익을 높이는 도구',
        'ch': '只需按一下就能增加您的收益的工具',
        'ru': 'Инструмент, который увеличит Вашу прибыль с помощью одной кнопки',
        'it': 'Strumento che aumenta i tuoi profitti con un tasto',
        'jap': '1つのボタンで利益を増やすツールです',
        'port': 'Ferramenta que aumenta seus lucros com um botão',
        'turk': 'Kârınızı bir düğmeyle artıran araçlar',
        'viet': 'Công cụ tăng lợi nhuận chỉ với một nút',
        'spa': 'Herramienta que aumenta tus beneficios con un solo botón',
        'arab': 'أداة تزيد أرباحك بضغطة زر'
    },
    need: {
        'en': 'You need to do the following:',
        'fr': 'Vous devez effectuer les opérations suivantes:',
        'de': 'Sie müssen Folgendes tun:',
        'ko': '다음을 따라야 합니다.',
        'ch': '您需要执行以下操作：',
        'ru': 'Вам нужно сделать следующее:',
        'it': 'Ecco cosa devi fare:',
        'jap': '以下の操作を行う必要があります。',
        'port': 'Você precisa fazer o seguinte:',
        'turk': 'Aşağıdakileri gerçekleştirmelisiniz:',
        'viet': 'Bạn cần làm như sau:',
        'spa': 'Tienes que hacer lo siguiente',
        'arab': 'عليك القيام بما يلي:'
    },
    info_list1: {
        'en': '1. Enter the $ARTY amount which you will invest in staking',
        'fr': '1. Saisissez le montant de jetons $ARTY que vous comptez placer en staking',
        'de': '1. Geben Sie die Anzahl $ARTY ein, die Sie staken möchten',
        'ko': '1. 스테이킹에 투자할 $ARTY 수량을 입력합니다.',
        'ch': '1. 输入您将投入质押的 $ARTY 数量',
        'ru': '1. Введите количество $ARTY, которую Вы инвестируете в стейкинг',
        'it': '1. Inserisci la quantità di $ARTY che metterai in staking',
        'jap': '1. 賭けに投じる$ARTYの金額を入力します',
        'port': '1. Insira o valor $ARTY que você investirá em staking',
        'turk': '1. Hisse ile yatırıma yönlendireceğiniz $ARTY miktarını girin',
        'viet': '1. Nhập số ARTY$ sẽ đầu tư vào stake',
        'spa': '1. Introduce la cantidad de $ARTY que vas a invertir en el staking',
        'arab': '1. أدخل مبلغ ARTY$ الذي ستستثمره في التخزين'
    },
    info_list2: {
        'en': '2. See how much profit you will get at the end of each year of staking',
        'fr': '2. Voyez combien de bénéfices vous obtiendrez à la fin de chaque année de staking',
        'de': '2. Sehen Sie, wie viel Profit Sie am Ende eines jeden Einsatzjahres erzielen werden',
        'ko': '2. 스테이킹한 해가 끝날 때쯤 얼마의 수익을 받게 될지 확인합니다.',
        'ch': '2. 查看您在每年做质押的时候能获得多少收益',
        'ru': '2. Посмотрите, какую прибыль Вы получите в конце каждого года стейкинга',
        'it': '2. Vedi quanto profitto avrai alla fine di ciascun anno di staking',
        'jap': '2. 賭けを行った年の年末時点で獲得できる利益を確認します',
        'port': '2. Veja quanto lucro você obterá no final de cada ano de staking',
        'turk': '2. Her hisse alım yılının sonunda ne kadar kâr elde edeceğinizi görün',
        'viet': '2. Xem bạn sẽ thu được bao nhiêu lợi nhuận vào cuối mỗi năm stake',
        'spa': '2. Mira la ganancia que tendrás al final de cada año de inversión',
        'arab': '2- اعرف مقدار الربح الذي ستحصل عليه في نهاية كل عام من التخزين'
    },
    info_list3: {
        'en': '3. Press the button «Stake $ARTY» to confirm the action',
        'fr': '3. Appuyez sur le bouton «Placer les jetons $ARTY en staking» pour confirmer laction',
        'de': '3. Drücken Sie auf die Schaltfläche „$ARTY staken“, um die Aktion zu bestätigen',
        'ko': '3. $ARTY 스테이킹 버튼을 눌러 작업을 확인합니다.',
        'ch': '3. 按下“质押 $ARTY”按钮确认操作',
        'ru': '3. Нажмите кнопку "Стейкать $ARTY" для подтверждения действия',
        'it': '3. Premi il tasto "Stake $ARTY" per confermare l`operazione',
        'jap': '3. 「$ARTYを賭ける」ボタンを押してアクションを確定します',
        'port': '3. Pressione o botão “Stake $ARTY para confirmar a ação',
        'turk': '3. Eylemi onaylamak için "$ARTY Hissesi Al" düğmesine basın',
        'viet': '3. Nhấn nút "Stake ARTY$" để xác nhận hành động',
        'spa': '3. Pulsa el botón "Stake $ARTY" para confirmar la acción',
        'arab': '3. اضغط على زر "Stake $ ARTY" للتأكيد '
    },
    info_list4: {
        'en': '4. Interest payments for staking are credited annually to your balance',
        'fr': '4. Vos jetons $ARTY généreront des gains dici un mois',
        'de': '4. Innerhalb eines Monats werden Ihre $ARTY-Token Profite generieren',
        'ko': '4. 한 달 이내에 $ARTY 토큰에서 수익이 발생합니다',
        'ch': '4. 一个月内，您的 $ARTY 代币将产生收益',
        'ru': '4. Выплаты процентов за стейкинг происходят ежегодно зачисляются на Ваш баланс',
        'it': '4. Entro un mese, i tuoi token $ARTY genereranno profitti',
        'jap': '4. 1ヶ月かけて、$ARTYトークンが利益を生み出します',
        'port': '4. Dentro de um mês, seus tokens $ARTY irão gerar lucros',
        'turk': '4. Bir ay içerisinde $ARTY tokenleriniz kâr sağlayacaktır',
        'viet': '4. Trong một tháng, token ARTY$ của bạn sẽ tạo ra lợi nhuận',
        'spa': '4. En un mes, tus tokens $ARTY generarán beneficios',
        'arab': '4. في غضون شهر، ستحقق عملاتك $ ARTY أرباحًا'
    },
    info_list5: {
        'en': '5. If you want to close staking before the end of the first year, the withdrawal fee will be 25%. After the end of the first year, the withdrawal fee will be 0%',
        'fr': '5. Si vous souhaitez clôturer le staking avant la fin de la première année, les frais de retrait seront de 25%. Après la fin de la première année, les frais de retrait seront de 0 %',
        'de': '5. Wenn Sie Ihre Einsätze vor Ablauf des ersten Jahres beenden möchten, beträgt die Rücknahmegebühr 25 %. Nach Ablauf des ersten Jahres beträgt die Rücknahmegebühr 0%',
        'ko': '5. 첫 해가 끝나기 전 스테이킹을 종료하고자 할 경우, 출금 수수료는 25%입니다. 첫 해가 끝난 후 출금 수수료는 0%입니다.',
        'ch': '5. 如果你想在第一年结束前结束质押，提现费为 25%。第一年结束后，提现费用为 0%',
        'ru': '5. Если Вы захотите закрыть стейкинг до конца первого года, комиссия за вывод средств составит 25%. После окончания первого года комиссия за вывод средств составит 0%',
        'it': '5. Se vuoi chiudere lo staking prima della fine del primo anno, le commissioni per il prelievo saranno del 25%. Dopo la fine del primo anno, le commissioni per il prelievo saranno dello 0%',
        'jap': '5. 1年目の年末までに賭けを終了したい場合は、25％の出金手数料が発生します。1年目の年末を過ぎると、出金手数料が0％になります。',
        'port': '5. Se você quiser fechar o staking antes do final do primeiro ano, a taxa de retirada será de 25%. Após o final do primeiro ano, a taxa de retirada será de 0%',
        'turk': '5. İlk yıl bitmeden önce hisse alım işlemini kapatmak isterseniz, %25 oranında cayma bedeli alınır. İlk yılın bitiminden itibaren cayma bedeli %0`dır.',
        'viet': '5. Nếu bạn muốn đóng stake trước khi kết thúc năm đầu tiên, phí rút tiền sẽ là 25%. Sau khi kết thúc năm đầu tiên, phí rút tiền sẽ là 0%',
        'spa': '5. Si quieres cerrar tu inversión antes del final del primer año, la comisión por el retiro será de 25%. Después de finalizar el primer año, la comisión por el retiro será de 0%',
        'arab': '5- إذا كنت ترغب في إغلاق التخزين قبل نهاية السنة الأولى، فستكون رسوم السحب 25%. بعد نهاية العام الأول، ستكون رسوم السحب 0%'
   },
    info_list6: {
        'en': '6. If you want to close staking before the end of the first year, the withdrawal fee will be 25%. After the end of the first year, the withdrawal fee will be 0%',
        'fr': '6. Cliquez sur le bouton «Clôturer le staking» pour mettre fin au staking',
        'de': '6. Klicken Sie auf die Schaltfläche „Staking beenden“, um das Staking abzuschließen',
        'ko': '6. 스테이킹을 완료하려면 „스테이킹 종료“ 버튼을 클릭하십시오.',
        'ch': '6. 点击“结束质押”按钮完成质押',
        'ru': '6. Нажмите кнопку «Закрыть стейкинг», чтобы завершить стейкинг.',
        'it': '6. Clicca sul tasto "Chiudi staking" per terminare lo staking',
        'jap': '6. 賭けを終了するには「賭けの終了」ボタンをクリックします',
        'port': '6. Clique no botão "Fechar staking" para completar o staking',
        'turk': '6. Hisse alımını tamamlamak için "Hisse alımını kapat" düğmesine basın',
        'viet': '6. Nhấn nút "Đóng stake" để hoàn thành việc stake',
        'spa': '6. Haz clic en el botón "Cerrar Staking" para completar el staking',
        'arab': '6. انقر فوق الزر "إغلاق التخزين" لإتمام عملية التخزين'
    },
    info_list7: {
        'en': 'The longer you hold $ARTY tokens, the higher the profit!',
        'fr': 'Plus vous détenez vos jetons $ARTY longtemps, plus les gains seront élevés!',
        'de': 'Je länger Sie $ARTY-Token halten, desto höher ist der Profit!',
        'ko': '$ARTY 토큰을 오래 보유할수록 더 많은 수익을 얻을 수 있습니다!',
        'ch': '质押 $ARTY 代币的时间越长，收益越高！',
        'ru': 'Чем дольше Вы держите токены $ARTY, тем выше прибыль!',
        'it': 'Più a lungo tieni i token $ARTY in staking e maggiore sarà il profitto!',
        'jap': '$ARTYを長期間保有すればするほど、利益が増えます！',
        'port': 'Quanto mais tempo você mantiver os tokens $ARTY, maior será o lucro!',
        'turk': '$ARTY tokenlerini ne kadar uzun süre tutarsanız, kârınız o kadar yüksek olur!',
        'viet': 'Càng nắm giữ token ARTY$ càng lâu, lợi nhuận càng lớn!',
        'spa': 'Cuanto más tiempo mantengas los tokens $ARTY, ¡mayores serán los beneficios!',
        'arab': 'كلما طالت مدة احتفاظك ب$ ARTY، زاد الربح!'
    },
    depo_arty: {
        'en': 'Deposit',
        'fr': 'Dépôt',
        'de': 'Einzahlung',
        'ko': '입금액',
        'ch': '存款',
        'ru': 'Депозит',
        'it': 'Deposita',
        'jap': '預け入れ',
        'port': 'Depósito',
        'turk': 'Yatır',
        'viet': 'Gửi',
        'spa': 'Depositar',
        'arab': 'إيداع'
    },
    cost: {
        'en': 'Cost',
        'fr': 'Coût',
        'de': 'Kosten',
        'ko': '비용',
        'ch': '费用',
        'ru': 'Стоимость',
        'it': 'Costo',
        'jap': 'コスト',
        'port': 'Custo',
        'turk': 'Maliyet',
        'viet': 'Chi phí',
        'spa': 'Coste',
        'arab': 'الكلفة'
    },
    days_passed: {
        'en': 'Days passed',
        'fr': 'Jours passés',
        'de': 'Vergangene Tage',
        'ko': '경과일',
        'ch': '天数',
        'ru': 'Дней прошло',
        'it': 'Giorni trascorsi',
        'jap': '経過日数',
        'port': 'Dias se passaram',
        'turk': 'Geçen gün sayısı',
        'viet': 'Ngày đã qua',
        'spa': 'Días pasados',
        'arab': 'الأيام'
    },
    status: {
        'en': 'Status',
        'fr': 'Statut',
        'de': 'Status',
        'ko': '상태',
        'ch': '状态',
        'ru': 'Статус',
        'it': 'Stato',
        'jap': 'ステータス',
        'port': 'Status',
        'turk': 'Durum',
        'viet': 'Trạng thái',
        'spa': 'Estado',
        'arab': 'حالة'
    },
    date_start: {
        'en': 'Date start',
        'fr': 'Date de début',
        'de': 'Startdatum',
        'ko': '시작일',
        'ch': '开始日期',
        'ru': 'Дата начала',
        'it': 'Data di inizio',
        'jap': '開始日',
        'port': 'Data de início',
        'turk': 'Başlangıç Tarihi',
        'viet': 'Ngày bắt đầu',
        'spa': 'Fecha de inicio',
        'arab': 'تاريخ البدء'
    },
    date_end: {
        'en': 'Date end',
        'fr': 'Date de fin',
        'de': 'Enddatum',
        'ko': '종료일',
        'ch': '结束日期',
        'ru': 'Дата конца',
        'it': 'Data di fine',
        'jap': '終了日',
        'port': 'Data final',
        'turk': 'Bitiş Tarihi',
        'viet': 'Ngày kết thúc',
        'spa': 'Fecha de finalización',
        'arab': 'تاريخ الانتهاء'
    },
    actions: {
        'en': 'Actions',
        'fr': 'Actions',
        'de': 'Aktionen',
        'ko': '작업',
        'ch': '行动',
        'ru': 'Действия',
        'it': 'Azioni',
        'jap': 'アクション',
        'port': 'Ações',
        'turk': 'Eylemler',
        'viet': 'Hoạt động',
        'spa': 'Acciones',
        'arab': 'أجراءات'
    },
    not_data: {
        'en': 'No data available...',
        'fr': 'Aucune donnée disponible...',
        'de': 'Keine Daten verfügbar …',
        'ko': '데이터가 없습니다...',
        'ch': '无可用数据…',
        'ru': 'Данные недоступны...',
        'it': 'Nessun dato disponibile...',
        'jap': '利用可能なデータがありません…',
        'port': 'Não há dados disponíveis...',
        'turk': 'Mevcut veri yok...',
        'viet': 'Không có dữ liệu kha dụng...',
        'spa': 'No hay datos disponibles...',
        'arab': 'لا تتوفر بيانات...'
    },
    staking: {
        'en': 'STAKING',
        'fr': 'STAKING',
        'de': 'STAKING',
        'ko': '스테이킹',
        'ch': '质押',
        'ru': 'Стейкинг',
        'it': 'STAKING',
        'jap': '賭け',
        'port': 'STAKING',
        'turk': 'HİSSE ALIMI',
        'viet': 'STAKE',
        'spa': 'STAKING',
        'arab': 'التخزين'
    },
    title2: {
        'en': '$ARTY STAKING',
        'fr': 'Staking $ARTY',
        'de': '$ARTY ANLEGEN',
        'ko': '$ARTY 스테이킹',
        'ch': '$ARTY质押',
        'ru': 'Стейкинг $ARTY',
        'it': '$ARTY STAKING',
        'jap': '$ARTYを賭ける',
        'port': '$ARTY STAKING',
        'turk': '$ARTY HİSSESİ',
        'viet': 'STAKE $ARTY',
        'spa': 'INVERTIR EN $ARTY',
        'arab': 'تخزين $ARTY'
    },
    increase: {
        'en': 'Increase your profit',
        'fr': 'Augmentez vos bénéfices',
        'de': 'Steigern Sie Ihren Profit',
        'ko': '수익을 증가시키세요.',
        'ch': '增加您的收益',
        'ru': 'Увеличьте свою прибыль',
        'it': 'Aumenta il tuo profitto',
        'jap': '利益を増やす',
        'port': 'Aumente seu lucro',
        'turk': 'Kârınızı arttırın',
        'viet': 'Gia tăng lợi nhuận của bạn',
        'spa': 'Aumenta tu ganancia',
        'arab': 'زد أرباحك'
    },
    multiply: {
        'en': 'Multiply your profit',
        'fr': 'Multipliez vos bénéfices',
        'de': 'Vervielfachen Sie Ihren Profit',
        'ko': '수익을 배가하세요.',
        'ch': '让您的收益翻倍',
        'ru': 'Умножьте свою прибыль',
        'it': 'Moltiplica il tuo profitto',
        'jap': '利益を倍増させる',
        'port': 'Multiplique seu lucro',
        'turk': 'Kârınızı çoğaltın',
        'viet': 'Nhân lên lợi nhuận của bạn',
        'spa': 'Multiplica tu ganancia',
        'arab': 'ضاعف أرباحك'
    },
    maximize: {
        'en': 'Maximize your profit',
        'fr': 'Maximisez vos bénéfices',
        'de': 'Maximieren Sie Ihren Profit',
        'ko': '수익을 극대화하세요.',
        'ch': '尽可能提高您的收益',
        'ru': 'Максимизируйте свою прибыль',
        'it': 'Massimizza il tuo profitto',
        'jap': '利益を最大化する',
        'port': 'Maximize seu lucro',
        'turk': 'Kârınızı en üst seviyeye çıkarın',
        'viet': 'Tối đa hóa lợi nhuận của bạn',
        'spa': 'Maximiza tu ganancia',
        'arab': 'حقق أقصى الأرباح'
    },
    year1: {
        'en': '1 YEAR',
        'fr': '1 AN',
        'de': '1 JAHR',
        'ko': '1년',
        'ch': '1 年',
        'ru': '1 ГОД',
        'it': '1 ANNO',
        'jap': '1年',
        'port': '1 ANO',
        'turk': '1 YIL',
        'viet': '1 NĂM',
        'spa': '1 AÑO',
        'arab': 'سنة واحدة'
    },
    years: {
        'en': 'YEARS',
        'fr': 'ANNÉES',
        'de': 'des Jahres',
        'ko': '년',
        'ch': '年数',
        'ru': 'ГОДА',
        'it': 'ANNI',
        'jap': '年',
        'port': 'JANEIRO',
        'turk': 'YILLAR',
        'viet': 'NĂM',
        'spa': 'AÑOS',
        'arab': 'سنوات'
    },
    apr: {
        'en': 'APR',
        'fr': 'TAUX D`INTÉRÊT ANNUEL DE',
        'de': 'Effektiver Jahreszins',
        'ko': 'APR',
        'ch': '月 ',
        'ru': 'Годовая ставка',
        'it': 'APR',
        'jap': '年利率',
        'port': 'APR',
        'turk': 'YAK.',
        'viet': 'Lãi suất',
        'spa': 'TASA ANUAL',
        'arab': 'APR'
    },
    afterYear1: {
        'en': 'Аfter 1 year:',
        'fr': 'Après 1 an :',
        'de': 'Nach 1 Jahr:',
        'ko': '1년 후:',
        'ch': '1 年后：',
        'ru': 'После 1-го года:',
        'it': 'Dopo 1 anno:',
        'jap': '1年後：',
        'port': 'Após 1 ano',
        'turk': '1 yıl sonra:',
        'viet': 'Sau 1 năm:',
        'spa': 'Después de 1 año:',
        'arab': 'بعد سنة واحدة:'
    },
    afterYear2: {
        'en': 'After 2 years:',
        'fr': 'Après 2 ans :',
        'de': 'Nach 2 Jahren:',
        'ko': '2년 후:',
        'ch': '2 年后：',
        'ru': 'После 2-го года:',
        'it': 'Dopo 2 anni:',
        'jap': '2年後：',
        'port': 'Após 2 anos:',
        'turk': '2 yıl sonra:',
        'viet': 'Sau 2 năm:',
        'spa': 'Después de 2 años:',
        'arab': 'بعد سنتين:'
    },
    afterYear3: {
        'en': 'After 3 years:',
        'fr': 'Après 3 ans :',
        'de': 'Nach 3 Jahren:',
        'ko': '3년 후:',
        'ch': '3 年后：',
        'ru': 'После 3-х лет:',
        'it': 'Dopo 3 anni:',
        'jap': '3年後：',
        'port': 'Após 3 anos:',
        'turk': '3 yıl sonra:',
        'viet': 'Sau 3 năm:',
        'spa': 'Después de 3 años:',
        'arab': 'بعد ٣ سنوات:'
    },
    history: {
        'en': 'Staking history',
        'fr': 'Historique du staking',
        'de': 'Anlagenverlauf',
        'ko': '스테이킹 이력',
        'ch': '质押记录',
        'ru': 'История стейкинга',
        'it': 'Cronologia staking',
        'jap': '賭け履歴',
        'port': 'Histórico de apostas',
        'turk': 'Hisse alım geçmişi',
        'viet': 'Lịch sử stake',
        'spa': 'Historial de inversión',
        'arab': 'سجل التخزين'
    },
    paymentYear1: {
        'en': '1 year interest payment',
        'fr': 'Paiement des intérêts sur 1 an',
        'de': 'Zinszahlung für 1 Jahr',
        'ko': '1년 이자 지급',
        'ch': '支付 1 年利息',
        'ru': 'Выплата процентов за 1 год',
        'it': '1 anno di pagamento di interessi',
        'jap': '年利の支払い',
        'port': '1 ano de pagamento de juros',
        'turk': '1 yıllık faiz ödemesi',
        'viet': 'Trả lãi 1 năm',
        'spa': 'Pago de 1 año de intereses',
        'arab': 'دفعة فائدة لمدة سنة واحدة'
    },
    paymentYear2: {
        'en': '2 years interest payment',
        'fr': 'Paiement des intérêts sur 2 an',
        'de': 'Zinszahlung für 2 Jahr',
        'ko': '2년 이자 지급',
        'ch': '支付 2 年利息',
        'ru': 'Выплата процентов за 2 года',
        'it': '2 anno di pagamento di interessi',
        'jap': '年利の支払い',
        'port': '2 ano de pagamento de juros',
        'turk': '2 yıllık faiz ödemesi',
        'viet': 'Trả lãi 2 năm',
        'spa': 'Pago de 2 año de intereses',
        'arab': 'دفعة فائدة لمدة سنة واحدة'
    },
    paymentYear3: {
        'en': '3 years interest payment',
        'fr': 'Paiement des intérêts sur 3 an',
        'de': 'Zinszahlung für 3 Jahr',
        'ko': '3년 이자 지급',
        'ch': '支付 3 年利息',
        'ru': 'Выплата процентов за 3 года',
        'it': '3 anno di pagamento di interessi',
        'jap': '年利の支払い',
        'port': '3 ano de pagamento de juros',
        'turk': '3 yıllık faiz ödemesi',
        'viet': 'Trả lãi 3 năm',
        'spa': 'Pago de 3 año de intereses',
        'arab': 'دفعة فائدة لمدة سنة واحدة'
    },
    modal_ttl: {
        'en': 'Close Staking',
        'fr': 'Fermez ce jalonnement',
        'de': 'Schließen Sie dieses Abstecken',
        'ko': '이 스테이 킹 닫기',
        'ch': '关闭这个赌注',
        'ru': 'Закрыть стейкинг',
        'it': 'Chiudere questo picchettamento',
        'jap': 'このかしめを閉じる',
        'port': 'Fechar este Staking',
        'turk': 'Bu Staking\'i kapat',
        'viet': 'Đóng Staking này',
        'spa': 'Cerrar este Staking',
        'arab': 'إغلاق هذا عمادا'
    },
    modal1: {
        'en': 'Are you shure you want to close staking?',
        'fr': 'Êtes-vous sûr de vouloir fermer le jalonnement?',
        'de': 'Sind Sie sicher, dass Sie das Abstecken schließen möchten?',
        'ko': '스테이 킹을 닫으시겠습니까?',
        'ch': '你确定要关闭赌注吗？',
        'ru': 'Вы уверены, что хотите закрыть стейкинг?',
        'it': 'Sei sicuro di voler chiudere il picchettamento?',
        'jap': '本当にかしめを閉じたいですか？',
        'port': 'Tem certeza de que deseja fechar o staking?',
        'turk': 'Staking\'i kapatmak istediğine emin misin?',
        'viet': 'Bạn có chắc chắn muốn đóng staking?',
        'spa': '¿Estás seguro de que quieres cerrar el staking?',
        'arab': 'هل أنت متأكد من أنك تريد إغلاق عمادا?'
    },
    modal2: {
        'en': 'You withdrawal fee is',
        'fr': 'Vos frais de retrait sont',
        'de': 'Ihre Auszahlungsgebühr beträgt',
        'ko': '출금 수수료는',
        'ch': '你的提款费是',
        'ru': 'Ваша комиссия за вывод средств составляет',
        'it': 'Si tassa di prelievo è',
        'jap': 'あなたの出金手数料は',
        'port': 'Você taxa de retirada é',
        'turk': 'Para çekme ücretiniz',
        'viet': 'Phí rút tiền là',
        'spa': 'Su tarifa de retiro es',
        'arab': 'رسوم السحب هي'
    },
    modal_close: {
        'en': 'Close Staking',
        'fr': 'Fermer le Jalonnement',
        'de': 'Schließen Sie das Abstecken',
        'ko': '스테이 킹 닫기',
        'ch': '近距离押注',
        'ru': 'Закрыть стейкинг',
        'it': 'Chiudere picchettamento',
        'jap': '閉じるかしめ',
        'port': 'Fechar Staking',
        'turk': 'Yakın Staking',
        'viet': 'Đóng Cược',
        'spa': 'Replanteo Cerrado',
        'arab': 'إغلاق عمادا'
    }
}